import { TournamentsBody } from 'modules/arena/reports/model/bodies';
import { KpiGrid } from 'modules/arena/reports/components/KpiCard';
import { Panel } from 'modules/arena/reports/components/Panel';
import { DataTable } from 'modules/arena/reports/components/DataTable';
import { AreaProps } from 'modules/arena/reports/areas/shared';
import { CapacityBarList } from 'shared/components/charts/CapacityBarList';

export function TournamentsArea({ body, meta, controller }: AreaProps<TournamentsBody>) {
  const { changeTable, tableLoading } = controller;
  return (
    <div className="flex flex-col gap-6">
      <KpiGrid metrics={body.metrics} meta={meta} />

      <Panel title="Preenchimento por categoria" subtitle="Na unidade de vagas do torneio: duplas ou jogadores">
        {body.categories.length ? (
          <CapacityBarList
            items={body.categories.map((category) => ({ ...category, capacity: category.capacity ?? 0 }))}
            formatRatio={(item) => `${item.value} de ${item.capacity}`}
          />
        ) : (
          <p className="text-sm text-ink-secondary">Nenhuma categoria com esses filtros.</p>
        )}
      </Panel>

      <DataTable
        title="Categorias"
        table={body.table}
        loading={tableLoading}
        onChange={changeTable}
        footnote="Uma dupla com pagamento dividido conta como uma inscrição."
      />
    </div>
  );
}
